/**
 * Identifier Masking Utilities
 *
 * Provides functions to mask sensitive identifiers (clientId, sessionId, etc.)
 * in logs to prevent PII leaks and maintain privacy/compliance.
 *
 * Usage:
 * ```typescript
 * import { maskId } from './mask';
 * logger.debug('Client ID:', maskId(clientId)); // "abc1...xyz9"
 * ```
 */

/**
 * Mask sensitive ID for logging (privacy/compliance protection)
 * Shows first 4 and last 4 chars: "abc123...xyz789"
 *
 * @param id The identifier to mask
 * @returns Masked string (e.g., "abc1...xyz9") or "****" for short/empty IDs
 */
export function maskId(id: string | null | undefined): string {
    if (!id || id.length < 8) return '****';
    return `${id.slice(0, 4)}...${id.slice(-4)}`;
}
